import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import ContentCard from '@/components/base/ContentCard';
import { categories } from '@/mocks/home';
import { contents } from '@/mocks/contents';
import { btn } from '@/lib/ui';

const CategoryBrowse = () => {
  const [active, setActive] = useState('all');

  const list = useMemo(
    () => (active === 'all' ? contents : contents.filter((item) => item.category === active)),
    [active],
  );
  const visible = list.slice(0, 8);

  return (
    <section className="border-y border-background-200 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="主题分类"
            title="按兴趣挑，找到你最想看的现场"
            desc="六个栏目覆盖热点、娱乐、社会、科技、生活与影视解说，切换分类即可快速筛选。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div
            className="mt-8 flex gap-1 overflow-x-auto rounded-full border border-background-200 bg-background-50 p-1"
            role="tablist"
            aria-label="内容分类筛选"
          >
            {categories.map((category) => (
              <button
                key={category.id}
                type="button"
                role="tab"
                aria-selected={active === category.id}
                onClick={() => setActive(category.id)}
                className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-xs font-label transition-colors md:text-sm ${
                  active === category.id
                    ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className={`${category.icon} text-sm`} />
                </span>
                {category.name}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {visible.map((item, index) => (
            <Reveal key={item.id} delay={(index % 4) * 70}>
              <ContentCard item={item} />
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <Link to={active === 'all' ? '/category' : `/category?category=${active}`} className={btn('outline', 'md')}>
            查看该分类全部内容
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CategoryBrowse;